/**
 * Integrytas Group - CSM. Pure builder for the active-language option list.
 *
 * A language is named by ONE function, localeName (injected here as nameOf so
 * this module stays pure and testable). It was previously named by whichever of
 * three sources happened to have a row — curated csm_language_master_tl for the
 * UI locale, then the EN_US row, then Intl — which meant the seeded locales read
 * "English (US) / English (UK) / Spanish (Mexico)" while anything added later
 * fell through to Intl and read "British English (Scottish Standard English)".
 * Two naming schemes in one dropdown, decided by which rows a database happened
 * to be seeded with.
 *
 * Naming from the code also localises for free: the label follows the UI
 * language, where a curated _tl row was one fixed string per language unless
 * someone translated it into every other one.
 *
 * The current/primary locale sorts first; the rest sort by localized name.
 */
export interface LangRow { code: string; }
export interface LanguageOption { code: string; name: string; }

export function buildLanguageOptions(
  rows: LangRow[],
  primary: string,
  uiLocale: string,
  nameOf: (code: string, uiLocale: string) => string,
): LanguageOption[] {
  const opts: LanguageOption[] = rows.map(r => ({
    code: r.code,
    name: nameOf(r.code, uiLocale) || r.code,
  }));
  opts.sort((a, b) => {
    if (a.code === primary) return -1;
    if (b.code === primary) return 1;
    return a.name.localeCompare(b.name);
  });
  return opts;
}
